// extracted by mini-css-extract-plugin
export default {"PricingFaqRow":"PricingFaqRow_PricingFaqRow__6nFLg","answer":"PricingFaqRow_answer__++EcL"};